import { useContext } from "react";
import { MessageContext, MessageContextType } from "../containers/MessageContainer/MessageContainer";

const useMessageContext = (): MessageContextType => {
  return useContext(MessageContext);
};

export default useMessageContext;
